import { ColorOptions, Icon, Image, ModBox, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { Button } from '../AdminButton'
import { Clipboard } from 'react-native'
import errorImage from '../../assets/images/error_24px@2x.png'

interface ErrorModalProps {
  show: boolean
  errorTitle: string
  errorMessage: string
  serviceName: string
  traceId: string
  onDismiss: () => void
}

const ErrorView = (onClose: any, errorTitle: string, errorMessage: string, serviceName: string, traceId: string) => {
  const handleOnCopyClipboard = () => {
    if (traceId && traceId.length > 0) {
      Clipboard.setString(traceId)
    }
  }
  return (
    <ModBox borderRadius={8} bg={'WHITE'} w={472} padding={24} overflow={'auto'}>
      <Image source={errorImage} height={32} width={32} />
      <ModBox show={errorTitle?.length > 0}>
        <Spacer size={16} direction="vertical" />
        <Text fontFamily="jiotype-bold" color={'BLACK_21'} fontSize={16} title={errorTitle} />
        <Spacer size={8} direction="vertical" />
        <Text fontFamily="jiotype-medium" color={'BLACK_75'} fontSize={14} title={errorMessage} />
      </ModBox>
      <ModBox show={serviceName?.length > 0}>
        <Spacer size={24} direction="vertical" />
        <Text fontFamily="jiotype-medium" color={'BLACK_75'} fontSize={12} title={'Service Name'} />
        <Spacer size={4} direction="vertical" />
        <Text fontFamily="jiotype-medium" color={'BLACK_21'} fontSize={12} title={serviceName} />
      </ModBox>
      <ModBox show={traceId?.length > 0}>
        <Spacer size={24} direction="vertical" />
        <Text fontFamily="jiotype-medium" color={'BLACK_75'} fontSize={12} title={'Request ID'} />
        <Spacer size={4} direction="vertical" />
        <ModBox direction="row">
          <Text fontFamily="jiotype-medium" color={'BLACK_21'} fontSize={12} title={traceId} />
          <Spacer size={8} direction="horizontal" />
          <ModBox
            w={37}
            show={traceId?.length > 0}
            borderLeftWidth={1}
            borderLeftColor={'BORDER_COLOR'}
            onPress={handleOnCopyClipboard}
            alignItems={'center'}
            justifyContent={'center'}
            underlayColor={'GRAY_BORDER'}>
            <Icon color="PRIMARY" size={16} id="DUPLICATE" />
          </ModBox>
        </ModBox>
      </ModBox>
      <Spacer size={48} direction="vertical" />
      <ModBox w={'100%'} h={1} bg={'#E0E0E0' as ColorOptions} />
      <Spacer size={24} direction="vertical" />
      <ModBox w={'100%'} alignItems={'center'} justifyContent={'flex-end'}>
        <Button onPress={onClose} title={'Close'} color={'PRIMARY'} type={'SecondaryWithBg'} textColor={'WHITE'} />
      </ModBox>
    </ModBox>
  )
}
const ErrorModal = ({ show, errorTitle, errorMessage, serviceName, traceId, onDismiss }: ErrorModalProps) => {
  return (
    <ModalDialog
      show={show}
      onDismiss={onDismiss}
      children={ErrorView(onDismiss, errorTitle, errorMessage, serviceName, traceId)}
      type="CenteredWrap"
    />
  )
}

export { ErrorModal }
